import { SummaryContentComponentElement } from '~/core/shared/types';

// TODO: This is the grossest code ever written. It is hiding incorporated fields for unincorporated entities.

const incorporatedTypes = [
  'private company',
  'other incorporated entity',
  'trust',
];

const incorporatedAllowedFields = [
  'asic-registration',
  'directors',
  'acn',
  'credit-score-entity',
  'total-no-credit-enquiries-last-month',
  'total-no-credit-enquiries-last-3-month',
  'total-no-credit-enquiries-last-6-month',
  'total-no-credit-enquiries-last-12-month',
  'total-no-credit-enquiries-last-60-month',
];

export function checkIncorporatedEntity(
  elements: SummaryContentComponentElement[],
): boolean {
  const entityType = elements
    .find((e) => e.key === 'entity-type')
    ?.value.toLowerCase();

  if (entityType === undefined) {
    return false;
  }

  return incorporatedTypes.some((type) => entityType.includes(type));
}

export function filterIncorporatedFields(
  elements: SummaryContentComponentElement[],
  isIncorporatedEntity: boolean,
): SummaryContentComponentElement[] {
  if (isIncorporatedEntity) return elements;

  return elements.filter((e) => !incorporatedAllowedFields.includes(e.key));
}
